<template>
  <TutorialView
    :cards="cards"
    game="rondo"
  />
</template>

<script>
import TutorialView from '@/components/games/tutorial/TutorialView.vue';

export default {
  name: 'RondoTutorial',
  components: {
    TutorialView,
  },
  data: () => ({
    cards: [
      {
        text: 'GAME.RONDO.TUTORIAL.CARDS_WITH_WORDS',
      },
      {
        image: 'rosco',
        text: 'GAME.RONDO.TUTORIAL.ANSWER_FAST',
      },
      {
        text: 'GAME.RONDO.TUTORIAL.CLUES',
      },
    ],
  }),
  // created() {
  //   // Add pre-form
  //   this.cards.push({
  //     text: 'GAME.RONDO.TUTORIAL.BEFORE_STARTING',
  //     form: this.$store.getters['evaluate/byScreen']('rondo'),
  //   });
  // },
};
</script>
